import { type CenterFactory, Center as MantineCenter } from "@mantine/core";
import { polymorphicComponentWrapper } from "../../utilities";
import styles from "./center.module.scss";
import type { IProps } from "./center.types";

const Center = polymorphicComponentWrapper<CenterFactory, IProps>("Center", (props, ref) => {
    return <MantineCenter ref={ref} classNames={{ root: styles["container"] }} {...props} />;
});

export { Center };
